import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import Navbar from "./components/Navbar";
import Home from "./components/pages/Home";
import Solutions from "./components/pages/Solutions";
import OurWork from "./components/pages/OurWork";
import Resources from "./components/pages/Resources";
import AboutUs from "./components/pages/AboutUs";
import Blogs from "./components/pages/Blogs";
import PostPage from "./components/pages/postpage1";
import ContactUs from "./components/pages/ContactUs";
import Footer from "./components/Footer";
import SaralTransport from "./components/pages/SaralTransport";
import SaralEway from "./components/pages/SaralEway";
import OtherProducts from "./components/pages/Other_Products";
import OtherProductsDetails from "./components/pages/Other_Products_detail";
import Services from "./components/pages/Services";
import HireDedicatedDevelopers from "./components/pages/HireDedicatedDevelopers";
import PageNotFound from "./components/pages/PageNotFound";
import ScrollTop from "./components/ScrollTop";
import Contact from "./components/Contact";
import InterviewForm from "./components/InterviewForm";
import { ToastContainer } from "react-toastify";
import ScrollToTopButton from "./components/ScrollToTopButton";

import { captureTrafficSource, initGA, trackPage } from "./Analytics";


function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    captureTrafficSource();
    trackPage(location.pathname + location.search);
  }, [location]);

  return null;
}


function App() {

  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <RouteTracker />

      <ScrollTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/services" element={<Services />} />
        <Route path="/hire-dedicated-developers" element={<HireDedicatedDevelopers />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/postpage1" element={<PostPage />} />
        <Route path="/contactus" element={<Contact />} />
        <Route path="/saraltransport" element={<SaralTransport />} />
        <Route path="/saraleway" element={<SaralEway />} />
        <Route path="/otherproducts" element={<OtherProducts />} />
        <Route path="/schedule-interview" element={<InterviewForm />} />
        <Route path="/automationDetails/:productId" element={<OtherProductsDetails />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>

      <ScrollToTopButton />
      <Footer />
      <ToastContainer position="top-right" autoClose={1000} />
    </Router>
  );
}

export default App;
